import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

const requireFilter = require.context(
    './',
    false,
    /Base[A-Z]\w+\.(vue|js)$/
)

requireFilter.keys().forEach(fileName => {
    const filterConfig = requireFilter(fileName)

    const filterName = upperFirst(
        camelCase(
            fileName
                .split('/')
                .pop()
                .replace(/\.\w+$/, '')
        )
    )

    Vue.filter(filterName, filterConfig.default)
})


